import { UserContext } from '@application/contexts';
import { Routes } from '@application/routes';
import { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router';

type CompletedOnboardingGuardProps = {
  children: React.ReactNode;
};

const CompletedOnboardingGuard = ({ children }: CompletedOnboardingGuardProps) => {
  const { hasFinishedOnboarding } = useContext(UserContext);

  const navigate = useNavigate();

  useEffect(() => {
    if (!hasFinishedOnboarding) {
      navigate(Routes.ONBOARDING);
    }
  }, [hasFinishedOnboarding, navigate]);

  if (!hasFinishedOnboarding) {
    return false;
  }

  // cast as JSX element to remove type error in router file
  return children as React.JSX.Element;
};

export default CompletedOnboardingGuard;
